import shuffle from 'hs-lodash/shuffle';
import { CmsBusinessMaturityOption, CmsSignupIntentOption } from 'signup-constants/signupData/CmsOption';
import { BusinessBoxId } from 'business-in-a-box-constants/businessBoxId';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { CrmExperienceOption } from 'signup-constants/signupData/CrmExperienceOption';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { JobFieldOption } from 'signup-constants/signupData/JobFieldOption';
import { isOptionShufflingDisabled } from '../selenium/seleniumFeatures';
import { Data } from './DATA';
import { ProductExperienceOption } from './ProductExperienceOption';
export const shuffleOptions = function shuffleOptions(options) {
  return isOptionShufflingDisabled() ? options : shuffle(options);
};
export const DataOptions = {
  [Data.CompanySize]: Object.values(CompanySizeOption),
  [Data.JobField]: [...shuffleOptions([JobFieldOption.Sales, JobFieldOption.Marketing, JobFieldOption.Support, JobFieldOption.Admin]), JobFieldOption.Other],
  [Data.CrmExperienceLevel]: [CrmExperienceOption.None, CrmExperienceOption.HasUsedCrm, CrmExperienceOption.HasUsedHubSpot],
  [Data.HubInterest]: shuffleOptions([HubInterestOption.Sales, HubInterestOption.CustomerService, HubInterestOption.Marketing, HubInterestOption.CMS]),
  [Data.HubletSelection]: [HubletOption.na1, HubletOption.eu1],
  [Data.CmsSignupIntent]: [CmsSignupIntentOption.Business, CmsSignupIntentOption.Personal],
  [Data.CmsBusinessMaturity]: [CmsBusinessMaturityOption.ExploringIdea, CmsBusinessMaturityOption.ReadyToLaunch, CmsBusinessMaturityOption.RecentlyLaunched, CmsBusinessMaturityOption.EstablishedBusiness],
  [Data.BusinessBox]: [BusinessBoxId.OnlinePresence, BusinessBoxId.FindCustomers, BusinessBoxId.B2B, BusinessBoxId.DigitalEvent],
  [Data.ProductExperience]: [ProductExperienceOption.yes, ProductExperienceOption.no],
  [Data.ProblemAwareness]: [ProductExperienceOption.yes, ProductExperienceOption.no]
};